
import ApiService from "@/core/services/api.service";


export const SET_LISTA_SETOR = "setListTipoProtocolo";
export const SET_LISTA_SETOR_REV = "setListTipoProtocolosRev";
export const SET_MESSAGE_ALERT = 'setMensagem'
export const SET_SETOR = "setConta"
export const SET_LISTA_USUARIOS = "setListSetorUsuarios";



const actions = {
    //protocolos
    async create_setor(context, value) {

        await ApiService.post('setor', value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    async update_setor(context, value) {

        await ApiService.put('setor/' + value.id, value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    async listar_setor(context) {
        await ApiService.get('setor')
            .then(response => {
                context.commit(SET_LISTA_SETOR, response.data)
            })
            .catch((error) => {
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: 'error',
                    message: error.response.data
                })
            })
    },
    async listar_setor_filial(context,value) {
        await ApiService.get('setor/filial/'+value)
            .then(response => {
                context.commit(SET_LISTA_SETOR, response.data)
            })
            .catch((error) => {
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: 'error',
                    message: error.response.data
                })
            })
    },
    async listar_usuarios_setor(context,value) {
        await ApiService.get('usuario/setor/'+value)
            .then(response => {
                context.commit(SET_LISTA_USUARIOS, response.data)
            })
            .catch((error) => {
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: 'error',
                    message: error.response.data
                })
            })
    },
    async listar_usuarios(context, params) {
        await ApiService.get('usuario', {params: params})
            .then(response => context.commit(SET_LISTA_USUARIOS, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    





    set_setor(context, item) {
        context.commit(SET_SETOR, item)
    },

    async delete_setor(context, value) {


        await ApiService.delete("setor/" + value.id)
            .then((response) =>
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: "success",
                    message: response.data,
                })
            )
            .catch((error) =>
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: "error",
                    message: error.response.data,
                })
            );


        context.commit(SET_LISTA_SETOR_REV, value)


    },

 



};
const getters = {};

const mutations = {

    [SET_LISTA_SETOR](state, value) {
        state.lista_setor = value;
    },
    [SET_LISTA_USUARIOS](state, value) {
        state.lista_usuarios = value;
    },
    [SET_LISTA_SETOR_REV](state, value) {
        state.lista_setor = state.lista_setor.filter(
            (setor) => setor.id !== value.id
        );
    },
    [SET_SETOR](state, value) {
        state.setor = value;
    },
  
    [SET_MESSAGE_ALERT](state, value) {
        console.log(value)
        let customMessage;
        if (typeof value.message === "object") {

            customMessage = value.message.msg;
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },

    [SET_LISTA_SETOR](state, value) {
        state.lista_setor = value;
    },


};

const state = {
    lista_setor: [],
    lista_usuarios: [],

    setor: {},
    mensagem_alert: "",

};

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
